import React, { useState } from 'react';
import store from '../../store';
import { useGetRecords } from 'root/admin/components/hooks';
import { CreateNew, ShowMore } from 'root/admin/components';

import { Table, Column, Loader, Image, BooleanValue } from '@smartplatform/ui';
import { observer } from 'mobx-react';
import { observable, action } from 'mobx';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronUp, faChevronDown } from '@fortawesome/free-solid-svg-icons';

@observer
class MainSlidesList extends React.Component {
	@observable records;
	@observable record;
	@observable order;

	componentDidMount() {
		this.init();
	}

	init = async () => {
		const records = await store.model.MainSlide.find({ order: 'order DESC' });
		this.records = records;
	};

	@action setOrder = async record => {
		console.log('order', record);
		if (!record.order) {
			record.order = record.id;
			await record.save();
			return;
		}
		if (this.order === 'down') {
			const prev = await store.model.MainSlide.find({
				where: { order: { lt: record.order } },
				order: 'order DESC',
			});
			console.log('prev', prev);
			if (prev.length !== 0) {
				const prevOrder = prev[0].order;
				prev[0].order = record.order;
				record.order = prevOrder;
				await prev[0].save();
			}
		}
		if (this.order === 'up') {
			const next = await store.model.MainSlide.find({
				where: { order: { gt: record.order } },
				order: 'order ASC',
			});
			console.log('next', next);
			if (next.length !== 0) {
				const nextOrder = next[0].order;
				next[0].order = record.order;
				record.order = nextOrder;
				await next[0].save();
			}
		}
		this.order = '';
		await record.save();
		await this.init();
	};
	render() {
		const { rootPath, path } = this.props;
		if (!this.records) {
			return <Loader />;
		}
		return (
			<div>
				<CreateNew link={`${path}/new`} name={`Новая запись`} />
				<Table records={this.records} rootPath={rootPath}>
					<Column label="Имя" property="name" />
					<Column label="Используемый материал" property="name" relation="article" />
					<Column label="Ссылка на источник" property="link" />
					<Column label="Обложка" property="thumbnail" />
					<Column onClick={this.setOrder}>
						<span className="order">
							<FontAwesomeIcon
								className="order-up"
								icon={faChevronUp}
								style={{ marginRight: '1rem' }}
								onClick={() => (this.order = 'up')}
							/>
							<FontAwesomeIcon className="order-down" icon={faChevronDown} onClick={() => (this.order = 'down')} />
						</span>
					</Column>
				</Table>
			</div>
		);
	}
}

export default MainSlidesList;
